import axios     from 'axios';
import authStore from '@widesk-core/stores/authStore';

const ACCESS_ATTEMPTS = 10;
const ACCESS_RETRY_DELAY_MS = 1000;

export const requestTokenRefresh = async () => {
	const service = window.APP_CONFIG.services.find(service => service.id === 'account');

	const response = await axios.post(service?.configurations.api_endpoint + '/token/refresh', {
		refresh_token: authStore.refreshToken,
		from: 1,
	});

	return { token: response.data.token, refreshToken: response.data.refresh_token };
};

// Les droits d'un compte qu'on vient de rejoindre peuvent arriver après la réponse de l'API, qui garde
// en cache ceux d'un jeton selon sa seconde d'émission : seul un jeton émis plus tard les voit.
export const renewTokenUntil = async (hasAccess: () => Promise<boolean>) => {
	for (let attempt = 1; attempt <= ACCESS_ATTEMPTS; attempt++) {
		const { token, refreshToken } = await requestTokenRefresh();

		authStore.setToken(token);
		authStore.setRefreshToken(refreshToken);

		if (await hasAccess()) return true;

		if (attempt < ACCESS_ATTEMPTS) await new Promise(resolve => setTimeout(resolve, ACCESS_RETRY_DELAY_MS));
	}

	return false;
};
